"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __spreadArray = this && this.__spreadArray || function (to, from) {
  for (var i = 0, il = from.length, j = to.length; i < il; i++, j++) to[j] = from[i];

  return to;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = require("react");

var useKeyboardEvents = function (_a) {
  var initRef = _a.initRef,
      listRef = _a.listRef,
      _b = _a.isAutocomplete,
      isAutocomplete = _b === void 0 ? false : _b,
      context = _a.context,
      children = _a.children;
  var searchString = react_1.useRef('');
  var timeout = react_1.useRef();

  var _c = react_1.useState([]),
      currentOptions = _c[0],
      setCurrentOptions = _c[1];

  var _d = react_1.useContext(context),
      isExpanded = _d.isExpanded,
      setIsExpanded = _d.setIsExpanded,
      selectedValue = _d.selectedValue,
      onChange = _d.onChange,
      setSelectedValue = _d.setSelectedValue,
      onSelection = _d.onSelection;

  react_1.useEffect(function () {
    return function () {
      return clearTimeout(timeout.current);
    };
  }, []);

  var createFlatChildArray = function (c) {
    return react_1.Children.toArray(c).map(function (el) {
      var _a;

      if (react_1.isValidElement(el)) {
        return (_a = el === null || el === void 0 ? void 0 : el.props) === null || _a === void 0 ? void 0 : _a.value;
      }

      return el;
    });
  };

  react_1.useEffect(function () {
    setCurrentOptions(createFlatChildArray(children));
  }, [children, selectedValue]);
  return function (event) {
    var _a;

    var key = event.key;
    var listElement = listRef.current;
    var buttonElement = initRef.current;

    var newEvent = __assign({}, event);

    var currentlySelectedIndex = currentOptions.indexOf(selectedValue);
    var listIsActive = document.activeElement === listElement;
    var buttonIsActive = document.activeElement === buttonElement;
    if (!listElement || !currentOptions.length) return;

    var focusList = function () {
      if (!listIsActive) {
        listElement.focus();
      }
    };

    var changeWithValue = function (newValue) {
      newEvent.target.value = newValue;
      if (onChange) onChange(newEvent);
      if (setSelectedValue) setSelectedValue(newValue);
    };

    switch (key) {
      case 'ArrowDown':
        {
          if (!isExpanded) {
            setIsExpanded(true);
          }

          focusList();
          if (currentlySelectedIndex === currentOptions.length - 1) return;

          if (currentlySelectedIndex < 0) {
            changeWithValue(currentOptions[0]);
          } else {
            changeWithValue(currentOptions[currentlySelectedIndex + 1]);
          }

          if (onChange) onChange(newEvent);
          if (setSelectedValue) setSelectedValue((_a = event === null || event === void 0 ? void 0 : event.target) === null || _a === void 0 ? void 0 : _a.value);
          break;
        }

      case 'ArrowUp':
        {
          if (!isExpanded) {
            setIsExpanded(true);
          }

          focusList();
          if (currentlySelectedIndex <= 0) return;
          changeWithValue(currentOptions[currentlySelectedIndex - 1]);
          break;
        }

      case 'Enter':
        {
          if (listIsActive) {
            setIsExpanded(false);
            buttonElement.focus();
            if (onSelection) onSelection(currentOptions[currentlySelectedIndex]);
          }

          if (buttonIsActive && isExpanded) {
            listElement.focus();
          }

          break;
        }

      case 'Home':
        {
          var firstValue = currentOptions[0];

          if (isExpanded && selectedValue !== firstValue) {
            focusList();
            changeWithValue(firstValue);
          }

          break;
        }

      case 'End':
        {
          var lastValue = currentOptions[currentOptions.length - 1];

          if (isExpanded && selectedValue !== lastValue) {
            focusList();
            changeWithValue(lastValue);
          }

          break;
        }

      case 'Escape':
        {
          if (isExpanded) {
            setIsExpanded(false);
            buttonElement.focus();
          }

          break;
        }

      default:
        {
          if (isAutocomplete) return;
          searchString.current += key;
          clearTimeout(timeout.current);
          if (typeof window === 'undefined') return;
          timeout.current = window.setTimeout(function () {
            var selectedIndex = currentOptions.indexOf(selectedValue);

            var sortedOptions = __spreadArray(__spreadArray([], currentOptions.slice(selectedIndex + 1)), currentOptions.slice(0, selectedIndex + 1));

            var searchArray = selectedIndex < 0 ? currentOptions : sortedOptions;
            var match = searchArray.find(function (x) {
              return x.startsWith(searchString.current);
            });

            if (match) {
              changeWithValue(match);
            }

            searchString.current = '';
          }, 200);
        }
    }
  };
};

exports.default = useKeyboardEvents;